// extracted by mini-css-extract-plugin
module.exports = {"root":"WizardStepMenuItem-module__root__4hr_K","prev-dummy":"WizardStepMenuItem-module__prev-dummy__2PHJ_","next-dummy":"WizardStepMenuItem-module__next-dummy__2QzEl"};